import { render } from "./UsersPagination.vue?vue&type=template&id=704c219d&scoped=true"
import script from "./UsersPagination.vue?vue&type=script&lang=js"
export * from "./UsersPagination.vue?vue&type=script&lang=js"

import "./UsersPagination.vue?vue&type=style&index=0&id=704c219d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704c219d"]])

export default __exports__